import React from 'react';
import StoreRegister from 'javascripts/store_register';
import { getFontLoadingPromise } from 'javascripts/font_helpers';
import TimelineChart from './components/timeline_chart';
import createStore from './store';
import { hydrateTimelineConfig } from './store/actions';
import StoreProxy from './helpers/store_proxy_helper';
import { Provider } from 'react-redux';

class TimelineControl extends React.Component {
  constructor(props) {
    super(props);

    const store = createStore();
    StoreRegister.register('timelineControl', new StoreProxy(store));

    this.state = {
      store,
      areFontsLoaded: false,
    };

    this.state.store.dispatch(hydrateTimelineConfig(this.props.configuration));
  }

  componentDidMount() {
    getFontLoadingPromise().then(() => this.setState({ areFontsLoaded: true }));
  }

  componentWillUnmount() {
    StoreRegister.deregister('timelineControl');
  }

  render() {
    if (!this.state.areFontsLoaded) {
      return null;
    }

    return (
      <Provider store={this.state.store}>
        <TimelineChart store={this.state.store} />
      </Provider>
    );
  }
}

export default TimelineControl;
